import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcLeisureFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.655 19.472-.5 1.688a.97.97 0 0 1-.707.654A6 6 0 0 1 12 22q-.697 0-1.524-.19a.97.97 0 0 1-.736-.695l-.408-1.643zM11.88 2H12c1.67 0 3.023 2.62 3.023 7.543 0 1.574-.33 3.193-.701 4.667l-.225.865-.325 1.214a26 26 0 0 1-.579 1.893l-.128.355h-2.13l-.126-.352a27 27 0 0 1-.398-1.247l-.173-.618-.442-1.647c-.416-1.594-.817-3.39-.817-5.13C8.979 4.62 10.332 2 12 2 9.239 2 7 5.242 7 9.242c0 2.308.422 4.158 1.719 6.252l.212.333a18 18 0 0 1 1.454 2.71H8.94q-.52-.92-1.426-1.884l-.267-.276C4.941 14.054 4 12.041 4 9.514 4 5.51 7.492 2.249 11.635 2.01zm.517.02-.166-.015L12.12 2C16.37 2.122 20 5.431 20 9.514c0 2.43-.87 4.384-2.987 6.597l-.26.266q-1.1 1.108-1.693 2.16h-1.446l.106-.244q.466-1.041 1.05-1.996l.51-.806C16.577 13.397 17 11.548 17 9.24c0-3.806-2.027-6.926-4.603-7.22",
    clipRule: "evenodd"
  }));
}
var IcLeisureFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLeisureFill));

export { IcLeisureFill as I };
